import {CONFIG} from "../../config";
import axios from "axios";

async function GetDeviceCoresQuery(deviceId) {
    const location = CONFIG.API_URL + "device_heartbeat/get_cores/" + deviceId;
    const settings = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        }
    };
    try {
        return await axios.get(location, settings);
    } catch (e) {
        return e;
    }
}

export default GetDeviceCoresQuery;